import PageTitle from "../MainContents/PageTitle/PageTitle";
import styled from 'styled-components';
import { device } from '../MainContents/Style/StyleDevice';
import ScrollToTopOnMount from '../MainContents/AutoScrollTop'; 
import Tab from "./Tab";




const Main =styled.div`
    margin-top: 100px;
    width: 90%;
    margin: auto;
    @media ${device.mobile}{
        width: 95%;
        position: relative;
    }

`
const Mt =styled.div`
margin-top:130px;
@media ${device.mobile}{
  margin-top:80px;
  }
`;
const Course: React.VFC = () => {
  return (
    <Main>
      <ScrollToTopOnMount />
      <Mt></Mt>
      <PageTitle title={'コース/料金'} englishText={'Course&Price'} />
      <Tab />
    </Main>
    
  );
}
export default Course;